import { render } from "./MMHomePage.vue?vue&type=template&id=380ad661&scoped=true"
import script from "./MMHomePage.vue?vue&type=script&lang=js"
export * from "./MMHomePage.vue?vue&type=script&lang=js"

import "./MMHomePage.vue?vue&type=style&index=0&id=380ad661&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380ad661"]])

export default __exports__